var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Report__Entity" },
    [
      _c("Entity", {
        ref: "entity",
        attrs: {
          "entity-type": "Report",
          "entity-id": _vm.videoId,
          innerComponent: _vm.innerComponent,
          innerComponentTitle: "עריכת וידאו",
          title: "וידאו",
          "back-button-text": "רשימת יחידות לימוד",
          "back-button-url": "lessons",
          widgets: _vm.widgets,
          actions: _vm.actions,
          preview: _vm.preview,
          "read-only": _vm.readOnly,
          entityReady: _vm.entityReady,
          activities: [],
        },
        on: { onFormSave: _vm.onFormSave, onFormDiscard: _vm.onFormDiscard },
        scopedSlots: _vm._u([
          {
            key: "mandatory",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("מספר מזהה לוידאו:"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold",
                      },
                      [_vm._v(_vm._s(_vm.videoId))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("צפייה מקדימה:"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold link",
                        on: { click: _vm.openVideo },
                      },
                      [_vm._v("קישור")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("מופעים לוידאו זה:"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold link",
                        on: { click: _vm.openVideoAppearance },
                      },
                      [_vm._v("הצגה")]
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }